var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginModalBottomBlob = function SvgLoginModalBottomBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 891 189"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0926E",
    fillRule: "evenodd",
    d: "M890.66 38.333v149.725H.66V.8c68.886 4.153 144.727 23.442 213.767 41.002 29.282 7.447 57.341 14.584 83.127 20.122 115.859 25.247 184.268 17.901 319.095.244l2.177-.3c83.611-11.507 191.917-26.414 271.834-23.535",
    clipRule: "evenodd"
  })));
};
export default SvgLoginModalBottomBlob;